function EtatCommunication(etat) {
    switch (etat) {
    case 0:
        return { Icone: 'fas fa-ban', Type: 'Non débuté', Couleur: 'text-muted' };
    case 5:
    case 8:
        return { Icone: 'fas fa-shipping-timed', Type: 'En cours', Couleur: 'text-info' };
    case 7:
        return { Icone: 'fas fa-shipping-fast', Type: 'Envoyé', Couleur: 'text-primary' };
    case 9:
        return { Icone: 'fas fa-check-circle', Type: 'Terminé', Couleur: 'text-success' };
    case 10:
        return { Icone: 'fas fa-exclamation-triangle', Type: 'Erreur', Couleur: 'text-danger' };
    default:
        return { Icone: 'fas fa-question-circle', Type: 'Inconnu', Couleur: 'text-warning' };
    }
}

export default EtatCommunication;



// WEBPACK FOOTER //
// ./src/App_Data/EtatCommunication.js